// eslint-disable @angular-eslint/template/interactive-supports-focus
// eslint-disable-entire-file @angular-eslint/template/click-events-have-key-events

import {
  Component,
  inject,
  makeStateKey,
  PLATFORM_ID,
  TransferState,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NewRelicService } from '../../services/newrelic.service';

@Component({
  selector: 'al-notify-link',
  imports: [CommonModule],
  standalone: true,
  template: `
    <div class="eva-3-container -sm">
      <div>
        <div class="eva-3-container -sm -fwith">
          <div class="illustration-container">
            <div
              class="eva-3-empty-state-message"
              style="display: flex; justify-content: center;"
            >
              <img
                class="success-image"
                src="https://media.staticontent.com/media/pictures/c5217939-3c91-4b6e-a761-3c1ce29f1418"
                alt="success-image"
              />
            </div>
          </div>

          <h3 class="eva-3-h3 title">Perfeito! Contas vinculadas</h3>
          <div
            style="display: flex; flex-direction: row; gap: 12px; align-items: center;"
          >
            <div class="eva-3-loader -md">
              <div class="loader-container">
                <div class="loader-spinner">
                  <div class="spinner-container spinner-left">
                    <div class="spinner-circle"></div>
                  </div>
                  <div class="spinner-container spinner-right">
                    <div class="spinner-circle"></div>
                  </div>
                </div>
              </div>
            </div>
            <p class="eva-3-body-1 status-message">
              <strong>Não sai daí!</strong> estamos retornando ao iFood
              automaticamente...
            </p>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./notify-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotifyLinkComponent {
  private platformId = inject(PLATFORM_ID);
  private transferState = inject(TransferState);
  private newrelicService = inject(NewRelicService);

  private readonly IFOOD_REDIRECT_TO_KEY =
    makeStateKey<string>('ifood_redirect_to');
  private redirectTo = '';
  protected redirectTimeLeft = 3;
  protected redirectInterval: ReturnType<typeof setInterval> | null = null;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.redirectTo = this.transferState.get(this.IFOOD_REDIRECT_TO_KEY, '');
      this.redirectInterval = setInterval(() => {
        this.redirectTimeLeft--;
        if (this.redirectTimeLeft === 0) {
          this.redirect();
        }
      }, 1000);
    }
  }

  redirect(event?: Event) {
    this.newrelicService.addPageAction('AccountLinkerNotifyRedirect');
    if (event) event.preventDefault();
    if (this.redirectInterval) clearInterval(this.redirectInterval);
    window.location.href = this.redirectTo;
  }
}
